<template>
  <basic-container>
    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>家庭医生工作站</el-breadcrumb-item>
        <el-breadcrumb-item>会员管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px; margin-right: 20px">
      <el-button type="success" @click="toCreateReportUser">新建报告解读用户</el-button>
    </div>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="onLoad(page, params)"
      @cell-click="handleCellClick"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"></template>
      <template slot-scope="scope" slot="menu1">
        <el-button type="text" size="small" @click="archiveType1(scope.row)">查看档案</el-button>
        <el-button v-if="false" type="text" size="small" @click="archiveType2(scope.row)">查看详情</el-button>
      </template>
      <!-- <template slot-scope="scope" slot="menu2">
        <el-button type="text" size="small">查看详情</el-button>
        <el-button v-if="false" type="text" size="small" @click="archiveType2(scope.row)">查看详情</el-button>
      </template>
      <template slot-scope="scope" slot="menu3">
        <el-button type="text" size="small">查看详情</el-button>
        <el-button v-if="false" type="text" size="small" @click="archiveType3(scope.row)">查看详情</el-button>
      </template> -->
      <template slot-scope="scope" slot="menu4">
        <el-button type="text" size="small" @click="archiveType4(scope.row)">查看详情</el-button>
      </template>
      <template slot-scope="scope" slot="menu5">
        <el-button type="text" size="small" @click="archiveType5(scope.row)">达标详情</el-button>
      </template>
      <template slot-scope="scope" slot="menu6">
        <el-button type="text" size="small" @click="archiveType6(scope.row)">查看方案</el-button>
      </template>
      <template slot-scope="scope" slot="menu7">
        <el-button type="text" size="small" @click="archiveType7(scope.row)">查看详情</el-button>
      </template>
      <template slot-scope="scope" slot="motion">
        <el-button type="text" size="small" @click="motionPrescription(scope.row)">查看随访</el-button>
      </template>
      <template slot-scope="scope" slot="AIConsult">
        <el-button type="text" size="small" @click="toAIHealthConsult(scope.row)">前往咨询</el-button>
      </template>
      <template slot-scope="scope" slot="drugPlan">
        <el-button type="text" size="small" @click="toDrugPlan(scope.row)">查看药物</el-button>
      </template>

      <template #consult="{ row, index }">
        <el-button type="text" @click="toHealthConsult(row, index)">
          {{ row.consult || "--" }}
        </el-button>
      </template>

      <template slot-scope="scope" slot="aiWeekReport">
        <el-button type="text" size="small" @click="toGenerateAiWeekReportByUser(scope.row)">{{ scope.row.aiWeekReport || "生成报告" }}</el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="toFinishPdf(scope.row)">PDF生成</el-button>
      </template>
      <!-- <template slot-scope="scope" slot="aiWeekReportByReport">
        <el-button type="text" size="small" @click="toGenerateAiWeekReportByUser(scope.row)">去生成</el-button>
      </template> -->
    </avue-crud>

    <!-- 自定义弹框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%">
      <div style="margin-left: 50px; margin-right: 50px">
        <avue-crud :option="option2" :data="data2">
          <template slot="value" slot-scope="{ row }">
            <div style="white-space: pre-line; word-break: break-all">
              {{ row.value }}
            </div>
          </template>
        </avue-crud>
      </div>
      <template #footer>
        <el-button type="primary" @click="dialogVisible = false">确认</el-button>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" :title="dialogTitle2" width="45%">
      <el-input v-model="inputValue" placeholder="请输入家庭医生" clearable></el-input>

      <template #footer>
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="updatedoc">确认修改</el-button>
      </template>
    </el-dialog>

    <el-dialog title="新建报告解读用户" :visible.sync="showReportUser" width="20%">
      <div class="infoModel">
        <div>姓名：</div>
        <div>
          <el-input v-model="reportUserName" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReportUser = false">取 消</el-button>
        <el-button type="primary" @click="createReportUser">创 建</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  doctorGetVip,
  // getSubHealth2,
  // getChronicDisease2,
  updatedoc,
  getSubHealthNew,
  getChronicNew,
  createReportUser,
  getAiWeekReportStateByUser,
  addAiWeekReportByUserReport,
  addAiWeekReportByUser,
} from "@/api/health/manage";
import func from "@/util/func";

export default {
  data() {
    return {
      bp: 0,
      calibration: 0,
      channel: window.localStorage.getItem("channel"),
      params: {
        channel: window.localStorage.getItem("channel"),
      },
      inputValue: "",
      updId: "",
      dialogVisible: false,
      dialogVisible2: false,
      dialogTitle2: "修改家庭医生",
      dialogTitle: "查看详情",
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: "headerClass",
      option: {
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        indexLabel: "序号",
        searchMenuSpan: 4,
        // menuWidth: 150, // 初始宽度
        column: [
          {
            label: "用户姓名",
            prop: "name",
            width: 110,
            // formatter: function (row) {
            //   return row.report_status === "不达标" ? row.name + "（血压不达标）" : row.name;
            // },
            search: true,
            searchValue: "",
            searchSpan: 4,
          },
          {
            label: "年龄",
            prop: "age",
            // search: true
          },
          {
            label: "性别",
            prop: "sex",
            type: "select",
            dicData: [
              { label: "未填写", value: 0 },
              { label: "男", value: 1 },
              { label: "女", value: 2 },
            ],
          },
          // {
          //   label: ' 家庭医生',
          //   prop: 'doc',
          //   search: true,
          //   searchSpan: 4
          // },
          {
            label: "渠道",
            prop: "channel",
            // search: true,
            width: 160,
          },
          {
            label: "数字档案",
            prop: "menu1",
          },
          {
            label: "疾病风险状态",
            prop: "menu4",
            // search: true
          },
          {
            label: "药品方案",
            prop: "drugPlan",
            // search: true
          },
          {
            label: "健康管理方案",
            prop: "menu6",
            // search: true
          },
          {
            label: "认知行为治疗状态",
            prop: "menu7",
            width: 140,
            // search: true
          },
          {
            label: "健康达标报告",
            prop: "menu5",
            dicData: [
              { label: "达标", value: 0 },
              { label: "未达标", value: 1 },
            ],
          },
          // {
          //   label: "管理档案生成（查看)",
          //   prop: "mobile",
          //   // search: true
          // },
          {
            label: "家医随访",
            prop: "motion",
            // search: true
          },
          {
            label: "院外咨询",
            prop: "consult",
            // search: true
          },
          {
            label: "人工智能辅助",
            prop: "AIConsult",
          },
          {
            label: "体检报告AI全科分析",
            prop: "aiWeekReport",
            width: 150,
          },
          // {
          //   label: '体检报告用户AI周报生成',
          //   prop: 'aiWeekReportByReport',
          //   width: 180
          // }
          {
            label: "生成时间",
            prop: "pdfDate",
            width: 160,
          },
        ],
      },
      option2: {
        align: "center", // 全局居中
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: "名称",
            prop: "name",
          },
          {
            label: "详情",
            prop: "value",
          },
        ],
      },
      data: [],
      data2: [],
      reportUserInfo: {},
      showReportUser: false,
      reportUserName: "",
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page },
    };
    sessionStorage.setItem("doctorManager", JSON.stringify(state));
    next();
  },
  methods: {
    toAIHealthConsult(row) {
      console.log("test row", row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/AIManage",
        query: parameter,
      });
    },
    onLoad(page, params) {
      console.log("onload");
      console.log("page:", page);
      console.log("params:", params);

      const savedState = sessionStorage.getItem("doctorManager");
      if (savedState) {
        const state = JSON.parse(savedState);
        page = state.page;
        params = state.params;
        this.page = state.page;
        this.params = state.params;
        this.bp = state.params.bp;
        this.option.column[0].searchValue = params.name;
        this.option.column[3].searchValue = params.doc;
        sessionStorage.removeItem("doctorManager");
      }

      params.channel = window.localStorage.getItem("channel");
      // 血压未达标
      params.bp = this.bp;
      params.calibration = this.calibration;

      doctorGetVip(page.currentPage, page.pageSize, params).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377" && res.data.docVip.length > 0) {
          res.data.docVip.forEach((item) => {
            // item.mobile = func.maskPhone(item.mobile);
            item.name = func.maskName(item.name);
          });
        }
        const data = res.data;
        this.page.total = data.total;
        this.data = data.docVip;
        console.log("doctorGetVip res", res);
      });
    },

    toHealthConsult(row, index) {
      if (!row.consult) {
        this.$message.error("用户无健康咨询");
        return;
      }

      console.log("chatId", row.group_chat_id);

      const parameter = {
        chatId: row.group_chat_id,
        wxUserId: row.wxUserId,
      };
      // updateChatDate(row.id)

      this.$router.push({
        path: "/doctor/healthConsult",
        query: parameter,
      });
    },

    archiveType1(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        // path: '/healthmanagement/dataarchive',
        path: "/doctor/dataarchive",
        query: parameter,
      });
    },

    archiveType2(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/subhealth",
        query: parameter,
      });
    },

    archiveType3(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/chronicdisease",
        query: parameter,
      });
    },

    archiveType4(row) {
      const parameter = {
        wxUserId: row.wxUserId,
        jkName: row.name,
        jkAge: row.age,
        jkSex: row.sex,
      };

      this.$router.push({
        path: "/doctor/criticalillness",
        query: parameter,
      });
    },

    archiveType5(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/healthreport",
        query: parameter,
      });
    },

    archiveType6(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/healthmanage",
        query: parameter,
      });
    },
    archiveType7(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/cognitivebehaviorald",
        query: parameter,
      });
    },
    toFinishPdf(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/pdfDownLoade",
        query: parameter,
      });
    },
    motionPrescription(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/motionFollowDetail",
        query: parameter,
      });
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem("channel"),
      };
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    searchChange(params, done) {
      params.channel = window.localStorage.getItem("channel");

      params.bp = this.bp;
      params.calibration = this.calibration;

      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    handleCellClick(row, column, cell, event) {
      const key = column.columnKey;
      console.log("key", key);

      if (key === "menu2") {
        this.dialogVisible = true;
        // getSubHealth2(row.wxUserId).then((res) => {
        //   this.data2 = res.data;
        //   console.log(res.data)
        // });
        getSubHealthNew(row.wxUserId).then((res) => {
          this.data2 = res.data;
          console.log(res);
        });
      }

      if (key === "menu3") {
        this.dialogVisible = true;
        // getChronicDisease2(row.wxUserId).then(res => {
        //   this.data2 = res.data
        // })
        getChronicNew(row.wxUserId).then((res) => {
          this.data2 = res.data;
        });
      }

      if (key === "doc") {
        this.dialogVisible2 = true;
        this.inputValue = row.doc;
        this.updId = row.wxUserId;
      }
    },

    updatedoc() {
      if (this.inputValue === "") {
        this.inputValue = " ";
      }
      updatedoc(this.updId, this.inputValue).then((res) => {
        this.dialogVisible2 = false;
        if (res.success) {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },

    bpClick() {
      if (this.bp === 1) this.bp = 0;
      else this.bp = 1;
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    calibrationClick() {
      if (this.calibration === 1) this.calibration = 0;
      else this.calibration = 1;
      this.onLoad(this.page, this.params);
    },

    toDrugPlan(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/doctor/drugDetails",
        query: parameter,
      });
    },

    toGenerateAiWeekReportByUser(row, done) {
      const wxUserId = row.wxUserId;
      const level = row.level;
      const t = this;

      this.$confirm("确认生成？")
        .then((_) => {
          if (level !== 999) {
            console.log("会员用户");
            getAiWeekReportStateByUser(wxUserId).then((res) => {
              const state = res.data.state;
              console.log("report: ", res.data);
              if (state === 0) {
                addAiWeekReportByUser(wxUserId).then((res) => {
                  t.onLoad(t.page, t.params);
                  window.alert("AI周报生成中！");
                });
              } else if (state === 1) {
                window.alert("AI周报生成中，请勿重复点击！");
              } else {
                window.alert("AI周报已生成，请勿重复点击！");
              }
            });
          } else {
            console.log("报告解读用户");
            getAiWeekReportStateByUser(wxUserId).then((res) => {
              const state = res.data.state;
              if (state === 0) {
                addAiWeekReportByUserReport(wxUserId).then((res) => {
                  window.alert("AI周报生成中！");
                  t.onLoad(t.page, t.params);
                });
              } else if (state === 1) {
                window.alert("AI周报生成中，请勿重复点击！");
              } else {
                window.alert("AI周报已生成，请勿重复点击！");
              }
            });
          }
          done();
        })
        .catch((_) => {});
    },

    toGenerateAiWeekReportByUserReport(row) {
      const wxUserId = row.wxUserId;
      const t = this;

      getAiWeekReportStateByUser(wxUserId).then((res) => {
        const state = res.data.state;
        console.log(state);
        if (state === 0) {
          addAiWeekReportByUserReport(wxUserId).then((res) => {
            window.alert("AI周报生成中！");
            t.onLoad(t.page, t.params);
          });
        } else if (state === 1) {
          window.alert("AI周报生成中，请勿重复点击！");
        } else {
          window.alert("AI周报已生成，请勿重复点击！");
        }
      });
    },

    toCreateReportUser() {
      this.showReportUser = true;
    },

    createReportUser() {
      console.log(this.reportUserName);
      // createReportUser
      const param = {
        name: this.reportUserName,
      };
      createReportUser(param).then((res) => {
        if (res.success) {
          this.showReportUser = false;
          this.onLoad(this.page, this.params);
          this.$message.success("新建成功!");
        }
      });
    },
  },
};
</script>
<style>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}

.infoModel {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
